import React from "react";
import NavBar from "../MyComponents/NavBar";
import "../MyComponents/reports.css";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";

export default function NigeriaBotDashboard() {
  const initialToken = localStorage.getItem("token");
  const history = useHistory();

  useEffect(() => {
    if (!initialToken) {
      history.push("/login");
    }
  }, [initialToken, history]);
  return (
    <>
      <NavBar detailView={true} />
      <div>
        <iframe
          id="reports"
          title="Nigeria Bot Dashboard"
          width="600"
          height="373.5"
          src="https://app.powerbi.com/view?r=eyJrIjoiMzFiOGU4NTUtZGRjNi00ZjQ1LTg5NGEtZTZhN2E0ZGFkMmUzIiwidCI6ImIyYTViZGZhLTU0MzktNGUxMy04YTBlLWRmODIwMTJiMTQ2YSIsImMiOjZ9"
          frameborder="0"
          allowFullScreen="true"
        ></iframe>
      </div>
    </>
  );
}
